import React, { useEffect, useMemo, useState } from "react";
import Loading from "../../Common/Loading";
import VbGrid, { VbGridColumn } from "../../Common/Vbgrid";

const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;

interface ApiResponse {
  hasGrid: boolean;
  title: string;
  columns: string[];
  types: ("S" | "D" | "N" | "B" | "-")[];
  aligns: ("left" | "right" | "center")[];
  rows: string[][];
  errorMessage: string;
}

const EL_ShowErrorDetailsForID: React.FC = () => {
  const params = new URLSearchParams(window.location.search);
  const id = params.get("ID") ?? "";
  const option = params.get("Option") ?? "";

  const [resp, setResp] = useState<ApiResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [size, setSize] = useState({ w: window.innerWidth - 20, h: window.innerHeight - 50 });

  useEffect(() => {
    document.title = "List of Session variables";
    document.body.style.margin = "0px";
  }, []);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(
          `${API_BASE_URL}api/error-details/?ID=${encodeURIComponent(id)}&Option=${encodeURIComponent(option)}`
        );
        const json: ApiResponse = await res.json();
        setResp(json);
        if (json.errorMessage) setErrorMsg(json.errorMessage);
      } catch (e) {
        setErrorMsg(String(e));
      } finally {
        setLoading(false);
      }
    })();
  }, [id, option]);

  // VB fn_Load: width = clientWidth-20, height = clientHeight-50
  useEffect(() => {
    const resize = () => setSize({ w: window.innerWidth - 20, h: window.innerHeight - 50 });
    window.addEventListener("resize", resize);
    return () => window.removeEventListener("resize", resize);
  }, []);

  // column names come straight from the query (DataTable column names); alignment/type from .NET type
  const columns: VbGridColumn[] = useMemo(
    () =>
      (resp?.columns ?? []).map((c, i) => ({
        header: c,
        align: resp?.aligns?.[i] ?? "left",
        type: resp?.types?.[i] ?? "S",
      })),
    [resp]
  );

  return (
    <>
      {loading && <Loading />}

      {errorMsg && (
        <div style={{
          position: "fixed", inset: 0, zIndex: 99999, background: "rgba(0,0,0,0.45)",
          display: "flex", alignItems: "center", justifyContent: "center",
        }}>
          <div style={{ background: "#fff", width: 506, maxWidth: "95vw", borderRadius: 4, overflow: "hidden", fontFamily: "Tahoma", fontSize: 14 }}>
            <div style={{ background: "#b00020", color: "#fff", padding: "6px 12px", textAlign: "center" }}>Error</div>
            <div style={{ padding: "20px 24px", color: "#525252", minHeight: 80, wordBreak: "break-word" }}>{errorMsg}</div>
            <div style={{ textAlign: "center", paddingBottom: 16 }}>
              <button onClick={() => setErrorMsg("")} style={{
                background: "#2f6089", color: "#fff", border: "none", borderRadius: 3, padding: "6px 28px", cursor: "pointer",
              }}>OK</button>
            </div>
          </div>
        </div>
      )}

      <div style={{ margin: 10 }}>
        {resp && resp.hasGrid && (
          <VbGrid
            title={resp.title}
            columns={columns}
            rows={resp.rows}
            width={size.w}
            height={size.h}
          />
        )}
      </div>
    </>
  );
};

export default EL_ShowErrorDetailsForID;